import { object, number } from 'yup'
import useTranslateWithLanguage from '../../Hooks/useTranslateWithLanguage'

import { CustomName } from '../Helpers'

const AttributesPercentageField = (language) => {
  const translate = useTranslateWithLanguage('formValidation', language)
  return object().shape({
    name: CustomName(translate),
    value: number().required(translate('percentageRequired')).min(0, translate('percentageMin')).max(100, translate('percentageMax'))
  })
}

export default AttributesPercentageField
